<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node class="newHeight"
    *matTreeNodeDef="let node"
    matTreeNodeToggle
    matTreeNodePadding
  >
    <label
      *ngIf="
        (options &&
          !options.readonly &&
          (node.level == 2 || isOtherCertificate(node))) ||
        (node.level == 1 && !isOtherCertificate(node))
      "
      >{{ node.item }}
    </label>
    <div class="toggleButtonContainer ml-3">
      <mat-checkbox
      *ngIf="
        options &&
        options.readonly &&
        (node.level == 2 || isOtherCertificate(node))
      "
        #matCheckbox
        [checked]="isNodeSelected(node)"
        (change)="todoLeafItemSelectionToggle(node, matCheckbox)"
        labelPosition="afer"
        >&nbsp;&nbsp;&nbsp;&nbsp;{{ node.item }}
      </mat-checkbox>

      <button
        type="button"
        *ngIf="
          options &&
          !options.readonly &&
          (node.level == 2 || isOtherCertificate(node))
        "
        (click)="clickElement(node)"
        class="treeButton"
      >
        <em class="fas fa-edit"></em>
      </button>

      <button
        type="button"
        *ngIf="
          options &&
          !options.readonly &&
          (node.level == 2 || isOtherCertificate(node))
        "
        (click)="updateChild(node)"
        class="treeButton"
      >
        <em class="fa-user-edit fas"></em>
      </button>
      <button
        type="button"
        *ngIf="
          options &&
          !options.readonly &&
          (node.level == 2 || isOtherCertificate(node))
        "
        (click)="removeChild(node)"
        class="treeButton"
      >
        <em class="fas fa-eraser"></em>
      </button>

      <button
        mat-icon-button
        type="button"
        *ngIf="
          options &&
          !options.readonly &&
          node.level == 1 &&
          !isOtherCertificate(node)
        "
        (click)="createChildReform(node)"
        class="treeButton"
      >
        <em class="fas fa-folder-plus"></em>
      </button>
      <button
        type="button"
        *ngIf="
          options &&
          !options.readonly &&
          node.level == 1 &&
          !isOtherCertificate(node)
        "
        (click)="updateReform(node)"
        class="treeButton"
      >
        <em class="fa-user-edit fas"></em>
      </button>
      <button
        type="button"
        *ngIf="
          options &&
          !options.readonly &&
          node.level == 1 &&
          !isOtherCertificate(node)
        "
        (click)="removeChild(node)"
        class="treeButton"
      >
        <em class="fas fa-eraser"></em>
      </button>
    </div>
  </mat-tree-node>

  <mat-tree-node
    *matTreeNodeDef="let node; when: hasNoContent"
    matTreeNodePadding
  >
    <mat-form-field appearance="fill">
      <mat-label>Nuevo elemento nivel </mat-label>
      <input matInput #itemValue />
    </mat-form-field>
    <button mat-button (click)="saveNode(node, itemValue.value)">
      {{ "commons.save" | translate }}
    </button>
  </mat-tree-node>

  <mat-tree-node
    *matTreeNodeDef="let node; when: hasChild"
    matTreeNodePadding
    [ngClass]="{
      NotExpanded: treeControl.isExpanded(node),
      Expanded: !treeControl.isExpanded(node)
    }"
  >
    <div class="toggleButtonContainer">
      <button
        type="button"
        class="treeToggleArrowButton"
        mat-icon-button
        matTreeNodeToggle
        [attr.aria-label]="'Toggle ' + node.item"
      >
        <div *ngIf="treeControl.isExpanded(node)" class="submitSearchButton">
          <em class="fas fa-angle-down"></em>
        </div>

        <div *ngIf="!treeControl.isExpanded(node)" class="submitSearchButton">
          <em class="fas fa-angle-up"></em>
        </div>
      </button>
    </div>

    <div class="treeLabelRoot" *ngIf="node.level == 0">
      {{ node.item }}
    </div>
    <div class="treeLabel" *ngIf="node.level > 0">
      {{ node.item }}
    </div>

    <div class="toggleButtonContainer">
      <button
        type="button"
        class="treeButton"
        *ngIf="options && !options.readonly && node.level == 1"
        (click)="createChildReform(node)"
      >
        <em class="fas fa-folder-plus"></em>
      </button>
      <button
        type="button"
        class="treeButton"
        *ngIf="options && !options.readonly && node.level == 1"
        (click)="updateReform(node)"
      >
        <em class="fa-user-edit fas"></em>
      </button>
      <button
        type="button"
        class="treeButton"
        *ngIf="options && !options.readonly && node.level == 1"
        (click)="removeChild(node)"
      >
        <em class="fas fa-eraser"></em>
      </button>

      <button
        type="button"
        *ngIf="
          options &&
          !options.readonly &&
          node.level == 0 &&
          isOtherCertificate(node)
        "
        (click)="createOtherCertificate(node)"
        class="ml-2"
      >
        <em class="fas fa-folder-plus"></em>
      </button>
      <button
        type="button"
        *ngIf="
          options &&
          !options.readonly &&
          node.level == 0 &&
          !isOtherCertificate(node)
        "
        (click)="addReform(node)"
        class="ml-2"
      >
        <em class="fas fa-folder-plus"></em>
      </button>
    </div>
  </mat-tree-node>
</mat-tree>

<div class="buttonsGroup" *ngIf="options && options.readonly">
  <div class="centerButton" style="margin-left: 69.5% !important">
    <button type="button" class="formButtonSelect" (click)="sendSelected()">
      Seleccionar
    </button>
  </div>
</div>
